/**
 * Seniors Management Page
 * 
 * Admin view of all seniors - redirects to existing Seniors list
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFamilyAuth } from '../../../contexts/FamilyAuthContext';

function SeniorsManagement() {
  const { isAdmin } = useFamilyAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to existing seniors list
    // The seniors list already has all functionality needed
    navigate('/family/senioren');
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#050816] text-white flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#5B4B8A] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-neutral-400">Weiterleitung...</p>
      </div>
    </div>
  );
}

export default SeniorsManagement;
